import { FuzzySearch } from "../helpers/fuzzy_search"
import { dataLayerPushEvent } from "../helpers/datalayer_helper"
import { loadBackgroundImages } from "../helpers/image_loader"

import { Elm as ElmSearch } from "../components/elm/Search/Main.elm"
import { setupDatepickerPorts } from "../components/elm_datepicker"

declare global {
  interface FilterData {
    autocomplete: AutocompleteData
  }

  interface Window {
    filterData: FilterData
  }
}

loadBackgroundImages()

const container = document.getElementById("elm-search-form")
const flags = window.filterData

if (container && flags) {
  const app = ElmSearch.Search.Main.init({ node: container, flags: flags })
  setupDatepickerPorts({ elmApp: app, gtm: { category: window.gtmCategory } })
  const fuzzySearch = new FuzzySearch(flags.autocomplete)
  app.ports.sendFuse.subscribe((text: string) => {
    app.ports.receiveFuse.send(
      fuzzySearch.search(text)
    )
  })
  app.ports.locationFieldFocused.subscribe((selector: string) => {
    const querySelector = document.querySelector(selector) as HTMLInputElement
    if (querySelector) {
      querySelector.select()
    }
  })
  app.ports.search.subscribe((url: Location) => {
    dataLayerPushEvent('Homepage', 'Search Form', '/search')
    const overlay = document.getElementById('js-loading-overlay')
    if (overlay) {
      overlay.classList.add('is-visible')
    }
    window.location = url
  })
}
